(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class SeedHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-seed-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-seed-hero-dot]'));
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Number(this.dataset.interval) || 6000;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.slideIndex) || 0);
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.index);
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    next() {
      this.show(this.index + 1);
    }

    start() {
      if (!this.autoplay || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('seed-hero-slider')) {
    customElements.define('seed-hero-slider', SeedHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
